import { APPLICATION_JSON } from "@/constans";
import { EventBus } from "@/event-bus";
import Vue from "vue";
import { handleResponse } from "../../handlers";
import { BACKEND_BASE_URL } from "../backend.types";
import { IResponseError } from "@/entities/common/common.types";
import { ITransportadorasService } from "@/services";
import { ITransportadora } from "@/entities/centros-efectivo-backend/transportadora";

export class TransportadorasService implements ITransportadorasService {
  async fetchAllTransportadorasByCodPaisCorto(
    codPaisCorto: string
  ): Promise<ITransportadora[] | undefined> {
    const headers = {
      Accept: APPLICATION_JSON,
    };
    const { response, error } = await handleResponse<ITransportadora[], IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/transportadora?codPaisCorto=` + codPaisCorto, {
        headers,
      })
    );
    if (error) {
      EventBus.$emit("on-service-transportadora-error", error.response?.data);
      return undefined;
    } else {
      return response!.data;
    }
  }
  async fetchAllTransportadoras(): Promise<ITransportadora[] | undefined> {
    const headers = {
      Accept: APPLICATION_JSON,
    };
    const { response, error } = await handleResponse<ITransportadora[], IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/transportadora/all`, {
        headers,
      })
    );
    if (error) {
      EventBus.$emit("on-service-transportadora-error", error.response?.data);
      return undefined;
    } else {
      return response!.data;
    }
  }
}
